// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"languages-module--wrapper--34QxP","active":"languages-module--active--24E2q"};